// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import AnimValueProgress from "../../../../../engines/components/animation/AnimValueProgress";
import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import BaseStateSprite from "../../../../../engines/components/state/BaseStateSprite";
import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import NodeUtil from "../../../../../engines/libs/NodeUtil";
import PromiseUtil from "../../../../../engines/libs/PromiseUtil";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { FileKind } from "../../../../define/FileKind";
import { MansionKind } from "../../../../define/MansionKind";
import ModelDialogLayer from "../../../../gameCommon/basic/ModelDialogLayer";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant, getOneBundleOnePrefab } from "../../../BundleResourceConfig";
import { backpackOpenType } from "../../../config/backpackConst";
import { NormalBackpackI } from "../../../manager/DefineInterface";
import NormalGameManager from "../../../manager/NormalGameManager";
import UserDataManage from "../../../model/UserDataManage";
import BackpackPrefab from "../../backpack/BackpackPrefab";
import MansionsMemberItem from "../member/MansionsMemberItem";
import MansionsMemberLayer from "../member/MansionsMemberLayer";

const {ccclass, property} = cc._decorator;


const c_arrowAdjust = [
    [
        {
            scalex: -1
            , skewx: 15
        }
    ]
    , [
        {
            scalex: -1
            , skewx: 0
        }
        , {
            scalex: 1
            , skewx: 0
        }
    ]
    , [
        {
            scalex: -1
            , skewx: -15
        }
        , {
            scalex: -1
            , skewx: 15
        }
        , {
            scalex: 1
            , skewx: -15
        }
    ]
    , [
        {
            scalex: -1
            , skewx: -30
        }
        , {
            scalex: -1
            , skewx: 0
        }
        , {
            scalex: 1
            , skewx: 0
        }
        , {
            scalex: 1
            , skewx: -30
        }
    ]
]
@ccclass
export default class MansionOperateLayer extends BasePopUpLayer {

	@property({ type: cc.Node, displayName:'' })
	spr_arrow: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeArrow: cc.Node = null;
	@property({ type: cc.Node, displayName:'' })
	nodeLineNormal: cc.Node = null;
	@property({ type: cc.Node, displayName:'' })
	nodeArrowBtnItem: cc.Node = null;

    @property(cc.Node)
    btnClose: cc.Node = null;
    @property(cc.Node)
    nodeBottom: cc.Node = null;
    @property(cc.Node)
    sprTalk: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelTalk: cc.Label = null;
	@property({ type: cc.Label, displayName:'' })
	labelGoodAdd: cc.Label = null;
	@property({ type: cc.Label, displayName:'' })
	labelMonterName: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	nodeMonterName: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelCosts: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelName: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelProgressName: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelProgressValue: cc.Label = null;


	@property({ type: AnimValueProgress, displayName:'' })
	progress: AnimValueProgress = null;

	@property({ type: cc.Label, displayName:'' })
	labelTagName: cc.Label = null;

	@property({ type: BaseStateSprite, displayName:'' })
	sprFlag: BaseStateSprite = null;

	@property({ type: cc.Node, displayName:'' })
	nodeBtnList: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	btnItem: cc.Node = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprHead: cc.Sprite = null;


    private preIntimateId = '';
    // private oriBtnZindex = -1;
    private touchMoveNode: cc.Node = null;
    // private oriTouchNodePos: cc.Vec2 = null;

    private oriIcon = '';
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.labelGoodAdd.node.active = false;
        this.btnItem.active = false;
        this.sprTalk.active = false;

    	this.nodeArrow.active = false;        
        this.initLayer();
    }

    initLayer() {
        let bWife = this._carryData.bWife;
        let key = this._carryData.key;
        let _parent: MansionsMemberItem = this._carryData._parent;
        let _pparent: MansionsMemberLayer = this._carryData._pparent;
        _pparent.node.scale = 0;
            
        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let wifeDataManage = mansionDataManage.wifeDataManage;
        let childDataManage = mansionDataManage.childDataManage;
        let wifeData = wifeDataManage.wifeData;
        let childData = childDataManage.childData;
        let nName = '';
        let icon = '';
        let costs = 0;
        let flagName = '';
        // let intimateName = '';
        let bnew = false;
        if (bWife) {
            let csvInfos = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.WIFE, key);
            if (!csvInfos) {
                console.error(`未找到wife表格数据 id= ` + key);
                return;
            }
            let wife = wifeData.lists.get(key);
            nName = csvInfos.real_name;
            icon = csvInfos.icon;
            costs = Number(csvInfos.costs);
            bnew = wife.bNew;
            flagName = '妻';
            // intimateName = wifeDataManage.getIntimateInfo(wife.intimacy);

            this.nodeMonterName.active = false;
        } else {
            let child = childData.lists.get(key);
            nName = child.name;
            icon = child.icon;
            costs = child.everyDayCost;
            bnew = child.bNew;

            let wInfo = wifeDataManage.getWifeInfo(child.motherId);
            if (wInfo) {
                this.labelMonterName.string = '母*' + wInfo.real_name;
            }
            if (!utilsModel.isValidNumberValue(nName)) {
                nName = '未取名';
            }
            flagName = child.bBoy ? '子' : '女';
            // intimateName = childDataManage.getIntimateInfo(child.intimacy);

            this.nodeMonterName.active = true;
        }

        this.labelName.string = nName;
        this.labelTagName.string = flagName;
        this.sprFlag.setFill(!bWife);
        this.labelCosts.string = data_control.getNumberFormat(costs*10000);
        // this.labelProgressName.string = intimateName;
        this.oriIcon = icon;
        this.refreshIcon(icon);
        this.refreshGoodState();
        this.refreshCardList();
    }

    refreshIcon(icon: string) {
        this.sprHead.node.active = false;
        let path = 'res/people/' + icon;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.mansionBundle).load(path, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    this.sprHead.node.active = true;
                    this.sprHead.spriteFrame = imgs;
                }
            }
        );
    }

    refreshGoodState(bPalyAni: boolean = false) {
        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let wifeDataManage = mansionDataManage.wifeDataManage;
        let childDataManage = mansionDataManage.childDataManage;
        let wifeData = wifeDataManage.wifeData;
        let childData = childDataManage.childData;
        let key = this._carryData.key;

        let intimacy = 0;
        let bWife = this._carryData.bWife;
        let intimateInfo = null;
        if (bWife) {
            let wife = wifeData.lists.get(key);
            intimacy = wife.intimacy;
            intimateInfo = wifeDataManage.getIntimateInfo(intimacy);
        } else {
            let child = childData.lists.get(key);
            intimacy = child.intimacy;
            intimateInfo = childDataManage.getIntimateInfo(intimacy);
        }
        this.labelProgressName.string = intimateInfo?.good_name || '';

        
        let preid = this.preIntimateId;
        let curid = intimateInfo.id;
        this.preIntimateId = curid;
        let good_max = intimateInfo.good_max;
        if (!utilsModel.isValidNumberValue(good_max)) {
            good_max = intimateInfo.good_min;
        }
        let maxGood = Number(good_max);
        if (preid != '' && curid != preid) {
            this.progress.setValue(0, true, false);
            let _parent: MansionsMemberItem = this._carryData._parent;
            _parent.initUI();
        }
        let progressValue = Math.min(intimacy / maxGood, 1);
        this.labelProgressValue.string = intimacy + '/' + maxGood;
        this.progress.setValue(progressValue, true, bPalyAni);
    }

    /**
     * 提升好感
     * @param goodValue 
     */
    promoteGoodValue(goodValue: number) {
        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let wifeDataManage = mansionDataManage.wifeDataManage;
        let childDataManage = mansionDataManage.childDataManage;
        let wifeData = wifeDataManage.wifeData;
        let childData = childDataManage.childData;
        let key = this._carryData.key;

        let bWife = this._carryData.bWife;
        if (bWife) {
            let wife = wifeData.lists.get(key);
            wife.intimacy += goodValue;
            wife.intimacy = Math.max(0, wife.intimacy);
            wifeData.saveLocalData();
        } else {
            let child = childData.lists.get(key);
            if (child) {
                child.intimacy += goodValue;
                child.intimacy = Math.max(0, child.intimacy);
                childData.saveLocalData();
            }
        }
       
        this.refreshGoodState(true);

        let nodeItem = cc.instantiate(this.labelGoodAdd.node);
        nodeItem.active = true;
        nodeItem.parent = this.labelGoodAdd.node.parent;
        let label = nodeItem.getComponent(cc.Label);
        label.string = '亲密度' + (goodValue >= 0 ? '+' : '') + goodValue;

        let tm = 0.35;
        cc.tween(nodeItem)
        .delay(0.7)
        .parallel(
            cc.tween(nodeItem).to(tm, {opacity: 50})
            , cc.tween(nodeItem).to(tm, {y: 20})
            // , cc.tween(nodeItem).to(tm, {scale: 0.9})
        )
        .removeSelf()
        .start();
    }

    refreshCardList() {
        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let mansionData = mansionDataManage.mansionData;
        let childDataManage = mansionDataManage.childDataManage;
        let childData = childDataManage.childData;

        let bWife = this._carryData.bWife;
        this.nodeBtnList.removeAllChildren();

        let csvInfos = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.MANSION_CARD);
        if (!csvInfos) {
            console.error(`未找到表格数据 MANSION_CARD`);
            return;
        }
        let key = this._carryData.key;
        let title = csvInfos.title;
        let curStage = 0;
        if (!bWife) {
            curStage = childData.lists.get(key).stage;
        }
        
        let CardType = MansionKind.CardType;
        for (let i = 0; i < mansionData.cardList.length; i++) {
            let o = mansionData.cardList[i];

            if (mansionData.useCardList[i]) {
                continue;
            }
            let info = csvInfos[o];
            if (!info) {
                console.error(`未找到卡片数据 id = `+o);
                continue;
            }

            let bUseWife = info[title.bUseWife];
            let bUseChild = info[title.bUseChild];

            let btnItem = cc.instantiate(this.btnItem);
            btnItem.active = false;
            btnItem.y = 0;
            btnItem.name = i + '';
            this.nodeBtnList.addChild(btnItem);

            let touchNode = btnItem.getChildByName('btnItem');
            let sprItem = touchNode.getChildByName('sprItem').getComponent(cc.Sprite);
            // let spr_yet_use = btnItem.getChildByName('spr_yet_use');
            let label = touchNode.getChildByName('labelName').getComponent(cc.Label);
            label.string = info[title.name];

            sprItem.node.active = false;
            let icon = info[title.icon];
            let path = 'res/operate/' + icon;
            getOneBundleByInstant(BUNDLE_SMALL_NAME.mansionBundle).load(path, cc.SpriteFrame
                , (err,imgs:cc.SpriteFrame)=>
                {
                    if(err){
                        console.log(err);
                    }else{
                        sprItem.node.active = true;
                        sprItem.spriteFrame = imgs;
                    }
                }
            );

            let icon2 = info[title.bg_icon];
            // spr_yet_use.active = mansionData.useCardList[i] ? true : false;
            if ( (bWife && !utilsModel.isValidNumberValue(bUseWife))
                || (!bWife && !utilsModel.isValidNumberValue(bUseChild))
                || ((!bWife && curStage 
                    < MansionKind.GeneralValue.CHILD_MIN_STAGE_OPERATE) 
                    && (o == CardType.DISPATCH || o == CardType.MARRY))
            ) {
                icon2 = 'spr_item4';
            } else {
                
                btnItem.on(cc.Node.EventType.TOUCH_START, this.onBtnTouchStart, this);
                btnItem.on(cc.Node.EventType.TOUCH_MOVE, this.onBtnTouchMove, this);
                btnItem.on(cc.Node.EventType.TOUCH_CANCEL, this.onBtnTouchEnd, this);
                btnItem.on(cc.Node.EventType.TOUCH_END, this.onBtnTouchEnd, this);
            }
            let path2 = 'res/operate/' + icon2;
            getOneBundleByInstant(BUNDLE_SMALL_NAME.mansionBundle).load(path2, cc.SpriteFrame
                , (err,imgs:cc.SpriteFrame)=>
                {
                    if(err){
                        console.log(err);
                    }else{
                        btnItem.active = true;
                        touchNode.getComponent(cc.Sprite).spriteFrame = imgs;
                    }
                }
            );
        }
    }

    /**
     * 显示对话
     * @param strText 
     */
    showTalk(strText: string) {
        strText = strText || '';

        if (strText == '') {
            return;
        }

        this.sprTalk.stopAllActions();
        this.sprTalk.active = true;
        this.sprTalk.opacity = 0;
        cc.tween(this.sprTalk)
        .to(0.2, {opacity: 255})
        .delay(3)
        .to(0.2, {opacity: 0})
        .call(()=> {
            this.sprTalk.active = false;
        })
        .start();

        this.labelTalk.string = strText;
    }

    onBtnTouchStart(event: cc.Event.EventTouch) {
        if (this.touchMoveNode) {
            return;
        }

        let nodeItem = event.getCurrentTarget();
        // this.oriTouchNodePos = nodeItem.getPosition().clone();
        this.touchMoveNode = nodeItem;
        // this.oriBtnZindex = nodeItem.getSiblingIndex();

        // let pos = this.node.convertToNodeSpaceAR(nodeItem.convertToWorldSpaceAR(cc.v2()));
        // this.oriTouchNodePos = pos.clone();
        // nodeItem.parent = this.node;
        // nodeItem.setPosition(pos);
    }

    onBtnTouchMove(event: cc.Event.EventTouch) {
        let nodeItem = event.getCurrentTarget();
        if (this.touchMoveNode != nodeItem) {
            return;
        }

        let normalLinePos = this.nodeLineNormal.convertToWorldSpaceAR(cc.v2());
        let local = event.getLocation();
        if (local.y >= normalLinePos.y) {
            this.nodeArrow.active = true;
            this.nodeArrowBtnItem.removeAllChildren();
            let len = this.nodeBtnList.childrenCount;
            let pos = this.nodeArrowBtnItem.convertToNodeSpaceAR(nodeItem.convertToWorldSpaceAR(cc.v2()));
            let nodeItemClone = cc.instantiate(nodeItem);
            this.nodeArrowBtnItem.addChild(nodeItemClone);
            nodeItemClone.setPosition(pos);

            let idx = nodeItem.getSiblingIndex();
            let adInfo = c_arrowAdjust[len-1][idx];
            this.spr_arrow.x = nodeItem.x;
            this.spr_arrow.scaleX = adInfo.scalex;
            this.spr_arrow.skewX = adInfo.skewx;
        } else {    
            this.nodeArrow.active = false;
        }
        // let delta = event.getDelta();
        // nodeItem.x += delta.x;
        // nodeItem.y += delta.y;
    }

    async onBtnTouchEnd(event: cc.Event.EventTouch) {
        let nodeItem = event.getCurrentTarget();
        if (this.touchMoveNode != nodeItem) {
            return;
        }

        let self = this;
        if (!this.nodeArrow.active) {
            self.touchMoveNode = null;
            return;
        }

        this.nodeArrow.active = false;

        let bBack = false;
        let bExit = false;
        let CardType = MansionKind.CardType;
        let bWife = this._carryData.bWife;
        let idx = Number(nodeItem.name);
        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let mansionData = mansionDataManage.mansionData;
        let cardType = mansionData.cardList[idx];

        if (cardType == CardType.REMOVE) {
            let bRemove = await this.removeMemberDialog();
            if (!bRemove) {
                self.touchMoveNode = null;
                return;
            }
        }

        if (true) {
            let pos1 = this.node.convertToNodeSpaceAR(nodeItem.convertToWorldSpaceAR(cc.v2()));
            nodeItem.parent = this.node;
            nodeItem.setPosition(pos1);

            let eTPos = this.sprHead.node.convertToWorldSpaceAR(cc.v2(0, this.sprHead.node.height/2));
            let ePos = this.node.convertToNodeSpaceAR(eTPos);
            let dTime = 0.95;
            ePos.y -= 200;
            nodeItem.setPosition(ePos);
            nodeItem.setScale(0.75);
            cc.tween(nodeItem)
            .delay(dTime)
            // .to(dTime, {scale:0.25, x: ePos.x, y: ePos.y }, {easing: cc.easing.backOut})
            .start();

            await PromiseUtil.sleep(dTime);
            if (!this.node || !cc.isValid(this.node)) {
                return;
            }
        }

        if (cardType == CardType.REMOVE) {
            this.onRemoveMember();
            bExit = true;
        }
        
        // if (NodeUtil.isNodeOverlap(nodeItem, this.sprHead.node)) {
        if (true) {
            // bBack = false;
            let bCanAddGood = true;
            let bCanUseCard = true;
            let csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.MANSION_CARD, cardType);
            if (!csvInfo) {
                console.error(`未找到MANSION_CARD表格数据 cardType = ` + cardType);
                return;
            }

            // 消耗金币
            let cosume_gold = csvInfo.cosume_gold;
            if (utilsModel.isValidNumberValue(cosume_gold)) {
                let cosumeGold = utilsModel.csvNumberParse(cosume_gold);
                let curGold = O1HD.getServices().userSrv.getCoins();
                if (cosumeGold != 0) {
                    if (curGold < cosumeGold) {
                        bCanUseCard = false;
                        O1HD.getModules().uiControlModule.showMessageBox(`金额不足，${csvInfo.name}使用失败`);
                        bCanAddGood = false;
                    } else {
                        O1HD.getServices().userSrv.setCoins(-cosumeGold, true);
                        // O1HD.getModules().uiControlModule.showMessageBox(`${csvInfo.name}消耗掉${data_control.getNumberFormat(cosumeGold)}铜钱`);
                    }
                }
            }

            if (bCanUseCard) {
                switch(cardType) {
                    case CardType.GIVE: {
                        this.sendGift();
                        break;
                    }
                    case CardType.SERVANT: {
                        this.onServant();
                        break;
                    }
                    case CardType.EDUCATION: {
                        this.onEducation();
                        break;
                    }
                    case CardType.NAME: {
                        this.changeName();
                        break;
                    }
                    // case CardType.REMOVE: {
                    //     let bRemove = await this.onRemoveMember();
                    //     if (!bRemove) {
                    //         bBack = true;
                    //     } else {
                    //         bExit = true;
                    //     }
                    //     break;
                    // }
                    case CardType.CONSULT: {
                        this.onTalk()
                        break;
                    }
                    case CardType.MARRY: {
                        this.onMarry();
                        bExit = true;
                        break;
                    }
                    case CardType.DISPATCH: {
                        this.onDispatch();
                        bExit = true;
                        break;
                    }
                    default: {

                    }
                    break;
                }
            }

            // 增加好感度
            if (bCanAddGood && utilsModel.isValidNumberValue(csvInfo.add_good)) {
                let addGoodLists = utilsModel.splitLineFeed(csvInfo.add_good);
                let addGoodWeightLists = utilsModel.splitLineFeed(csvInfo.good_weight);
                let goodWordLists: string[] = [];
                if (bWife) {
                    goodWordLists = utilsModel.splitLineFeed(csvInfo.good_word_wife);
                } else {
                    goodWordLists = utilsModel.splitLineFeed(csvInfo.good_word_child);
                }
                let idxLists = utilsModel.getWeightsIdxList(addGoodWeightLists, 1);
                let addGood = Number(addGoodLists[idxLists[0]]);
                if (isNaN(addGood)) {
                    addGood = 0;
                }
                this.promoteGoodValue(addGood);
                this.showTalk(goodWordLists[idxLists[0]]);
            }
        }
        
        if (bBack) {
            // cc.tween(nodeItem)
            // .to(0.2, {x: this.oriTouchNodePos.x, y: this.oriTouchNodePos.y})
            // .call(()=> {
            //     nodeItem.parent = self.nodeBtnList;
            //     nodeItem.y = 0;
            //     nodeItem.setSiblingIndex(self.oriBtnZindex);
            //     // self.oriBtnZindex = -1;
            //     self.touchMoveNode = null;
            // })
            // .start();
        } else {
            // 删除卡片数据
            mansionData.useCardList[idx] = true;
            mansionData.saveLocalData();

            nodeItem.destroy();
            // self.oriBtnZindex = -1;
            self.touchMoveNode = null;

            if (bExit) {
                this.btnClose.active = false;
                this.nodeBottom.active = false;
                this.nodeBtnList.active = false;
                await PromiseUtil.sleep(3);
                if (this.node && cc.isValid(this.node)) {
                    this.exitLayer();
                }
            }
        }
    }

    /**
     * 赠送礼物
     */
    async sendGift() {
        // let info = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.MANSION, 'send_promote_intimacy');
        // if (!info) {
        //     console.error(`未找到表格数据 MANSION send_promote_intimacy`);
        //     return;
        // }
        // let addGoods = Number(info.value);
        await new Promise<void>(async aresolve=>{
            let url = "backpack/backpackPrefab";
            let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.backPackGameBundle,url);
            if(prefab){
                let backpack = cc.instantiate(prefab);
                backpack.getComponent(BackpackPrefab).bindData(backpackOpenType.select,null,async (item:NormalBackpackI)=>{
                    NormalGameManager._instance.onOutGoods(item.id,1);
                    this.promoteGoodValue(item.goodValue || 0);

                    let mansionDataManage = UserDataManage.instance.mansionDataManage;
                    let childDataManage = mansionDataManage.childDataManage;
                    let childData = childDataManage.childData;
                    let key = this._carryData.key;

                    let bWife = this._carryData.bWife;
                    if (bWife) {
                        let talkList = [
                            '谢相公赠送礼物，奴家甚是喜欢'
                            , '相公你真好，知道奴家爱这个东西。'
                            , '相公送的礼物，奴家很喜欢'
                            , '相公真棒，奖励你一个亲亲'
                        ];
                        this.showRandomTalk(talkList);
                    } else {
                        const stageTalk = [
                            ['爹爹吃糖', '最喜欢爹爹了', '爹爹对我最好了', '亲亲爹爹。']
                            , ['谢谢爹爹', '日后不会让爹爹失望的', '爹爹对我好好啊', '我以后也要像爹爹那样']
                            , ['多谢父亲大人', '谢爹爹', '有劳爹爹费心了']
                            , ['多谢父亲大人', '谢爹爹', '有劳爹爹费心了']
                        ];
                        let child = childData.lists.get(key);
                        if (child) {
                            let talk = stageTalk[child.stage];
                            if (talk) {
                                this.showRandomTalk(talk);
                            }
                        }
                    }
                    aresolve();
                }
                );
                this.node.addChild(backpack);
            }
        });
    }

    /** 
     * 谈心
     */
    onTalk() {
        let info = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.MANSION, 'talk_promote_intimacy');
        if (!info) {
            console.error(`未找到表格数据 MANSION talk_promote_intimacy`);
            return;
        }
        let addGoods = Number(info.value);
        this.promoteGoodValue(addGoods);

        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let childDataManage = mansionDataManage.childDataManage;
        let childData = childDataManage.childData;
        let key = this._carryData.key;

        let bWife = this._carryData.bWife;
        if (bWife) {
            let talkList = [
                '相公今日如此有雅兴，奴家愿意相陪'
                , '相公遇到何时，可否让奴家分忧'
            ];
            this.showRandomTalk(talkList);
        } else {
            const stageTalk = [
                ['']
                , ['爹爹，我想你陪我玩']
                , ['能陪父亲大人说话是我的荣幸']
                , ['能陪父亲大人说话是我的荣幸']
            ];
            let child = childData.lists.get(key);
            if (child) {
                let talk = stageTalk[child.stage];
                if (talk) {
                    this.showRandomTalk(talk);
                }
            }
        }
    }

    /**
     * 嫁出
     */
    onMarry() {
        let bWife = this._carryData.bWife;
        if (bWife) {
            return;
        }

        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let childDataManage = mansionDataManage.childDataManage;
        let childData = childDataManage.childData;
        let key = this._carryData.key;

        let data = childData.lists.get(key);

        if (data.stage < MansionKind.GeneralValue.CHILD_MIN_STAGE_OPERATE) {
            return;
        }
        let wName = 'marry_son_earning';
        if (!data.bBoy) {
            wName = 'marry_girl_earning';
        }

        let info = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.MANSION, wName);
        if (!info) {
            console.error(`未找到表格数据 MANSION ` + wName);
            return;
        }
        let value = Number(info.value) * 10000;

        let intimacyInfo = childDataManage.getIntimateInfo(data.intimacy);
        if (intimacyInfo) {
            value *= (1 + Number(intimacyInfo.earning_scale));
        }

        O1HD.getServices().userSrv.setCoins(value, true, this.node);
        this.confirmRemoveMember();

        if (data.bBoy) {
            let talkList = [
                '如今孩儿成了赘婿，不能再为父亲大人尽孝了'
            ];
            this.showRandomTalk(talkList);
        } else {
            let talkList = [
                '如今孩多谢父亲大人替女儿找到归宿儿成了赘婿，不能再为父亲大人尽孝了'
            ];
            this.showRandomTalk(talkList);
        }
    }

    /**
     * 派遣
     */
    onDispatch() {
        let bWife = this._carryData.bWife;
        if (bWife) {
            return;
        }

        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let childDataManage = mansionDataManage.childDataManage;
        let childData = childDataManage.childData;
        let key = this._carryData.key;

        let data = childData.lists.get(key);
        if (data.stage < MansionKind.GeneralValue.CHILD_MIN_STAGE_OPERATE) {
            return;
        }
        let wName = 'dispatch_son_earning';
        if (!data.bBoy) {
            wName = 'dispatch_girl_earning';
        }

        let info = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.MANSION, wName);
        if (!info) {
            console.error(`未找到表格数据 MANSION ` + wName);
            return;
        }
        let value = Number(info.value) * 10000;
        
        let intimacyInfo = childDataManage.getIntimateInfo(data.intimacy);
        if (intimacyInfo) {
            value *= (1 + Number(intimacyInfo.earning_scale));
        }
        value = Math.floor(value);
        
        O1HD.getServices().userSrv.setCoins(value, true, this.node);
        this.confirmRemoveMember();

        if (data.bBoy) {
            let talkList = [
                '男儿自当征战沙场报效君王'
            ];
            this.showRandomTalk(talkList);
        } else {
            let talkList = [
                '谁说女子不如男，我要证明给他们看看'
            ];
            this.showRandomTalk(talkList);
        }
        
    }

    removeMemberDialog() {
        return new Promise<boolean>(resolve=> {
            ModelDialogLayer.show(
                ' 确认要逐出吗？'
                , ()=> {
                    resolve(false);
                }
                , () => {
                    resolve(true);
                }
                , '逐  出'
                , '我再想想'
            );
        });
    }

    /** 
     * 逐出
     */
    async onRemoveMember() {
        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let childDataManage = mansionDataManage.childDataManage;
        let childData = childDataManage.childData;
        let key = this._carryData.key;

        let bWife = this._carryData.bWife;
        if (bWife) {
            let talkList = [
                '奴家做错了什么让相公生气，者的要休了我吗?'
                , '相公三思啊'
                , '相公要是不喜欢奴家，奴家走便是了。'
            ];
            this.showRandomTalk(talkList);

            this.refreshIcon(this.oriIcon + '_cry');
            cc.tween(this.node)
            .delay(5)
            .call(()=> {
                this.refreshIcon(this.oriIcon);
            })
            .start();
            
        } else {
            // 小孩哭声 
            
            const stageTalk = [
                ['']
                , ['爹爹，这是要把我赶出家门吗']
                , ['孩儿不孝，不能为父亲大人分忧了']
                , ['孩儿不孝，不能为父亲大人分忧了']
            ];
            let child = childData.lists.get(key);
            if (child) {
                let talk = stageTalk[child.stage];
                if (talk) {
                    this.showRandomTalk(talk);
                }
            }
        }
        this.confirmRemoveMember();
    }

    /**
     * 确定逐出
     */
    confirmRemoveMember() {
        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let mansionData = mansionDataManage.mansionData;
        let wifeDataManage = mansionDataManage.wifeDataManage;
        let childDataManage = mansionDataManage.childDataManage;
        let wifeData = wifeDataManage.wifeData;
        let childData = childDataManage.childData;
        let _pparent: MansionsMemberLayer = this._carryData._pparent;

        let key = this._carryData.key;
        let bWife = this._carryData.bWife;
        if (bWife) {
            let wife = wifeData.lists.get(key);
            wife.state = MansionKind.WifeState.CAST_AWAY;
            wife.resetStateData();
            wifeData.saveLocalData();

            let csvInfos = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.WIFE, key);
            if (!csvInfos) {
                console.error(`未找到wife表格数据 id= ` + key);
            } else {
                let costs = Number(csvInfos.costs);
                mansionData.costGold -= costs;
            }
        } else {
            let child = childData.lists.get(key);
            mansionData.costGold -= child.everyDayCost;
            childData.removeItem(key);
            childData.saveLocalData();
        }
        mansionData.costGold = Math.max(0, mansionData.costGold);
        mansionData.saveLocalData();

        _pparent.refreshState();
    }

    /**
     * 改名
     */
    changeName() {
        let bWife = this._carryData.bWife;
        if (bWife) {
            return;
        }

        let key = this._carryData.key;
        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let childDataManage = mansionDataManage.childDataManage;
        let childData = childDataManage.childData;
        let data = childData.lists.get(key);

        utilsView.openPopupLayer(
            'prefab/operate/MansionOperateChangeName'
            , BUNDLE_SMALL_NAME.mansionBundle
            , this.node
            , {
                parent: this
                , curName: data.name
                , changeName: (name: string) => {
                    data.name = name;
                    childData.saveLocalData();
                    this.labelName.string = name;

                    let talkList = [
                        '谢谢爹爹，名字真好听'
                    ];
                    this.showRandomTalk(talkList);
                    
                    let _parent: MansionsMemberItem = this._carryData._parent;
                    _parent.initUI();
                }
            }
        );
    }

    /**
     * 侍寝
     */
    onServant() {
        let bWife = this._carryData.bWife;
        if (!bWife) {
            return false;
        } 

        let curDay = NormalGameManager._instance.getCurrentDay();
        let key = this._carryData.key;
        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let wifeDataManage = mansionDataManage.wifeDataManage;
        let mansionData = mansionDataManage.mansionData;
        let childDataManage = mansionDataManage.childDataManage;
        let wifeData = wifeDataManage.wifeData;
        let data = wifeData.lists.get(key);
        if (!data){
            console.error(`未找到数据`);
            return false;
        }

        if (data.lastServantDate == curDay || data.bFetation) {
            // 今日已侍寝
            let talkList = [
                '相公，让奴家休息两天嘛'
                , '相公，让奴家缓缓'
                , '人家已有身孕，不能为相公侍寝'
            ];
            this.showRandomTalk(talkList);
            return false;
        }

        if (data.intimacy < MansionKind.GeneralValue.SERVANT_INTIMATE) {
            let talkList = [
                '相公，我今日生体不适，不能侍寝'
                , '今天身体疲了，改日吧'
                , '相公公务繁多，改日吧'
                , '相公，我们相处再久一些。现在不合适'
            ];
            this.showRandomTalk(talkList);
            return false;
        }

        let wifeCount = wifeDataManage.ownWifeCount();
        let childCount = childDataManage.ownChildCount();

        if (wifeCount + childCount >= mansionData.curCapacity) {
            let talkList = ['相公，咱们家已经不能再添丁拉，家里住不下啦'];
            this.showRandomTalk(talkList);
            return false;
        }
        this.showRandomTalk(['你今日不忙啦，那奴家为你宽衣']);

        data.lastServantDate = NormalGameManager._instance.getCurrentDay();
        data.bFetation = true;
        wifeData.saveLocalData();

        this.refreshIcon(this.oriIcon + '_shy');
        cc.tween(this.node)
        .delay(2)
        .call(()=> {
            this.refreshIcon(this.oriIcon);
        })
        .start();
        
        // this.createChild(key);
        return true;
    }

    showRandomTalk(strList: string[]) {
        let idx = data_control.randomNumInt(0, strList.length - 1);
        let strTalk = strList[idx];
        this.showTalk(strTalk);
    }

    /**
     * 教育
     */
    onEducation() {
        let mansionDataManage = UserDataManage.instance.mansionDataManage;
        let childDataManage = mansionDataManage.childDataManage;
        let childData = childDataManage.childData;
        // let mansionData = mansionDataManage.mansionData;
        let key = this._carryData.key;
        let bWife = this._carryData.bWife;
        if (bWife) {
            return;
        }

        let data = childData.lists.get(key);
        let wName = 'stage_education_son';
        if (!data.bBoy) {
            wName = 'stage_education_girl';
        }

        let info = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.MANSION, wName);
        if (!info) {
            console.error(`未找到表格数据 MANSION ` + wName);
            return;
        }

        let educationCount = data.educationCount+1;
        let splits = utilsModel.splitLineFeed(info.value);
        let curStageCount = Number(splits[data.stage]);
        let bChangeStage = false;
        if (educationCount >= curStageCount && splits.length > data.stage) {
            data.educationCount = 0;
            data.stage++;
            bChangeStage = true;
        } else {
            data.educationCount++;
        }
        
        if (bChangeStage) {
            if (data.stage == splits.length) {
                if (data.bBoy) {
                    data.icon = 'spr_self';
                } else {
                    data.icon = ''
                    let csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.WIFE, data.motherId);
                    if (!csvInfo) {
                        console.error(`未找到wife表格数据 id= ` + key);
                    } else {
                        data.icon = csvInfo.icon;
                    }
                }

                PromiseUtil.nextFrame().then(()=> {
                    this.refreshCardList();    
                });
            } else {
                data.icon = mansionDataManage.getChildStageHead(data.bBoy, data.stage);

                let _parent: MansionsMemberItem = this._carryData._parent;
                _parent.initUI();
            }
            this.refreshIcon(data.icon);
        }
        childData.saveLocalData();
    }

    /** 
     * 帮助
     */
    onClickHelp() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        utilsView.openPopupLayer(
            'prefab/operate/MansionOperateHint'
            , BUNDLE_SMALL_NAME.mansionBundle
        );
    }

    refreshCardListTemp() {
        UserDataManage.instance.mansionDataManage.refreshCardList();
        this.refreshCardList();
    }

    onClickRefreshCard() {
        let self = this;
        O1HD.getManagers().soundMgr.playSound("anNiu");
        utilsModel.loadAndShowVideoAdTrans(()=>{
           self.refreshCardListTemp();
        },()=>{ 
 
        }, null, "府邸广告刷新卡牌");
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.exitLayer();
    }

    exitLayer() {
        let _pparent: MansionsMemberLayer = this._carryData._pparent;
        _pparent.node.scale = 1;
        this.destroyNode();
    }

    // update (dt) {}
}
